export class User {
  jwt?: string;
  jwt_refresh?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  role_name?:string;
  module_permissions?: { [key: string]: any } = {};

  fromJson(json: any): User {
    this.jwt = json?.jwt;
    this.jwt_refresh = json?.jwt_refresh;
    this.email = json?.email;
    this.first_name = json?.first_name;
    this.last_name = json?.last_name;
    this.role_name = json?.role_name;
    this.module_permissions = json?.module_permissions || {};
    return this;
  }
}

export interface LoggedInUserinfo{
  avatar: string | null;
  email: string;
  first_name: string;
  id: string;
  last_name: string;
  mfa_factor_id: string | null;
  mfa_active?: boolean | null;
  force_mfa?: boolean;
  role_id: string;
  role_name: string;
  active?: boolean;
  created_on?: string;
  address_information?: {
    id?: string | null;
    title?: string | null;
    short_address?: string | null;
    street_name?: string | null;
    city_name?: string | null;
    building_number?: string | null;
    unit_number?: string | null;
    additional_number?: string | null;
    zip_code?: string | null;
  } | null;
  contact_information?: {
    id?: string | null;
    contact_id?: string | null;
    full_name?: string | null;
    contact_email?: string | null;
    phone_number?: string | null;
    description?: string | null;
    contact_methods?: any;
    contact_labels?: Array<{ id?: string; name?: string; hex_color?: string; icon?: string }>;
    preferences?: {
      communication?: Array<{ days?: string[]; start_time?: string; end_time?: string }>;
    };
  } | null;
  user_preferences?: any;

  [key: string]: any;
}
